import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/service';
import { StatisticsResponse } from './types';
import { errorHandler } from '@/lib/utils/error-handler';

export const useStatistics = () => {
  const { api } = useApi();
  const statistics = useQuery<StatisticsResponse, Error>({
    queryKey: ['/statistics'],
    queryFn: async () => {
      try {
        const response = await api.get<StatisticsResponse>('/statistics');
        return response.data;
      } catch (error: any) {
        errorHandler(error);
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 10000,
    refetchInterval: 30000,
  });
  return { statistics };
};
